import locationService from "../../../services/location/LocationService";
import serviceProvider from "../../../services/provider/ProviderService";
import Timeselector from "vue-timeselector";
import serviceHolidays from "../../../services/holidays/serviceHolidays";
import { StorageService } from "../../../services/StorageService";
import YearCalendar from "../../year-calendar/YearCalendar.vue";
import serviceCalendar from "../../../services/calendar/serviceCalendar";
import branchService from "../../../services/branch/BranchService";
import dayjs from "dayjs";
import ServiceAppointment from "../../../services/appointment/ServiceAppointment";

export default {
    components: {
        YearCalendar,
        Timeselector
    },
    data() {
        return {
            vue: {
                lunes: false,
                martes: false,
                miercoles: false,
                jueves: false,
                viernes: false,
                sabado: false,
                domingo: false
            },

            desserts: [{
                lunes: "",
                martes: null,
                miercoles: "",
                jueves: "",
                viernes: "",
                sabado: "",
                domingo: ""
            }],
            activeDates: [],
            year: parseInt(new Date().toString().substring(10, 15)),
            activeClass: "red",
            location: {
                state: "",
                city: "",
                branche_id: null
            },
            selected: null,
            providers: [],
            states: [],
            cities: [],
            dissabledProvider: true,
            loading: false,
            time: {
                lunes: "",
                martes: "",
                miercoles: "",
                jueves: "",
                viernes: "",
                sabado: "",
                domingo: ""
            },
            timeFinish: {
                lunes: "",
                martes: "",
                miercoles: "",
                jueves: "",
                viernes: "",
                sabado: "",
                domingo: ""
            },
            capacity: {
                lunes: "",
                martes: "",
                miercoles: "",
                jueves: "",
                viernes: "",
                sabado: "",
                domingo: ""
            },
            range: {
                lunes: "",
                martes: "",
                miercoles: "",
                jueves: "",
                viernes: "",
                sabado: "",
                domingo: ""
            },
            dayAnswer: {
                lunes: "",
                martes: "",
                miercoles: "",
                jueves: "",
                viernes: "",
                sabado: "",
                domingo: ""
            },
            range: [0, 30],
            popupTime: "",
            popupTimeFinish: "",
            popupRange: "",
            popupCapacity: "",
            popupDayAnswer: "",
            dialog: false,
            validForm: false,
            selectedDay: [],
            saveDayEnable: [],
            activeArray: [],
            calendar: true,
            calendarAppointment: false,
            unifiedPharmacies: "",
            branch: "",
            menu2: false,
            menu: false,
            modal2: false,
            inActive: {},
            idBranch: ""
        };
    },

    created() {
        this.init();
        this.listUnified();
    },
    watch: {
        selected(){
            this.getDatesDeliveryPoint(this.selected);
            console.log('se modifico')
        }
    },
    methods: {
        listUnified() {
            ServiceAppointment.branchAll().then(response => {
                let branch = response.data;
                this.branch = branch.map(b => {
                    return {
                        name: b.idDeliveryPoint.name,
                        id: b.id,
                        address: b.idDeliveryPoint.address
                    };
                });
            });
        },

        actionButtonCalendar() {
            this.calendar = !this.calendar;
            this.calendarAppointment = !this.calendarAppointment;
        },

        toggleDate(dateInfo) {
            if (this.selected === null) {
                this.$notify({
                    group: "app",
                    type: "success",
                    text: "Escoger un prestador."
                });
                dateInfo.selected = false;
                dateInfo.className = "";
                return;
            } else {
                //por cada punto de entrega
                // this.getDatesDeliveryPoint(this.selected);
                // console.log("prestador", this.selected);
                this.dialog = true;
                this.selectedDay = dateInfo;
            }
        },
        saveOneDay(item) {
            if (!this.$refs.form.validate()) {
                return;
            }
            for (let i = 0; i < this.selected.length; i++) {
                this.idBranch = this.selected[i];
            }
            let theDate = dayjs(this.selectedDay.date);
            let active = {};
            active.idAppointment = [];

            active.idAppointment.push({
                Date: theDate.format("YYYY-MM-DD"),
                idUser: StorageService.getUserData().id,
                startTime: this.popupTime,
                endDate: this.popupTimeFinish,
                rankOfTime: parseInt(this.popupRange),
                capacity: parseInt(this.popupCapacity),
                responseDay: parseInt(this.popupDayAnswer)
            });
            active.idBranch = this.idBranch;
            active.active = 1;
            active.lastCreated = new Date().toISOString().substr(0, 10);
            this.activeArray.push(active);
            ServiceAppointment.saveCalendarAppointment({
                    AppointmentDetails: this.activeArray
                })
                .then(result => {
                    if (result.data.code === "Save successful") {
                        this.dialog = false;
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: "Calendario Modificado."
                        });
                        this.selected = "";
                    }
                    this.getDatesDeliveryPoint();
                    this.getHolidays();
                })
                .catch(erro => {
                    if (result.data.statusCode === 500) {
                        console.log(erro);
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "Error Almacenado."
                        });
                    }
                    this.dialog = false;
                });
        },
        ActiveDate(item) {

            console.log(this.selected, "prueba ", item);
            if (!this.$refs.form.validate()) {
                return;
            }

            for (let i = 0; i < item.length; i++) {
                let theDate = dayjs(this.selectedDay.date);

                let active = {
                    Date: theDate.format("YYYY-MM-DD"),
                    idUser: StorageService.getUserData().id,
                    idBranch: item[i]
                };
                this.activeArray = active;
            }

            console.log(this.activeArray);
            ServiceAppointment.Active(this.activeArray)
                .then(result => {
                    if (result.data.code === "Save successful") {
                        this.dialog = false;
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: "Calendario configurado éxitosamente."
                        });
                        this.selected = "";
                    }
                })
                .catch(erro => {
                    if (result.data.statusCode === 500) {
                        console.log(erro);
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "Error Almacenado."
                        });
                    }
                    this.dialog = false;
                });
        },
        DesactiveDate(item) {
            if (!this.$refs.form.validate()) {
                return;
            }
            console.log(item);
            for (let i = 0; i < item.length; i++) {
                let theDate = dayjs(this.selectedDay.date);

                let inActive = {
                    Date: theDate.format("YYYY-MM-DD"),
                    idUser: StorageService.getUserData().id,
                    idBranch: item[i]
                };
                this.inActive = inActive;
            }
            console.log(this.inActive);
            ServiceAppointment.inActive(this.inActive)
                .then(result => {
                    if (result.data.code === "INACTIVE_SUCCESSFUL") {
                        this.dialog = false;
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: "Calendario Modificado."
                        });
                        this.selected = "";
                        this.popupTime = "";
                        this.popupTimeFinish = "";
                        this.popupCapacity = "";
                        this.popupRange = "";
                        this.popupDayAnswer = "";
                    }
                })
                .catch(erro => {
                    console.log(erro);
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "Error Modificando Fecha."
                    });
                    this.dialog = false;
                });
        },
        closeDialog() {
            this.selected.selected = false;
            this.selected.className = "";
        },
        modifiedActiveDates(dateInfo, date) {
            console.log("Date: ", date);
        },
        add_sat_and_sun_of_year() {
            let theDate = dayjs(`${this.year}-01-01`);
            while (theDate.diff(theDate.endOf("year"), "day") !== 0) {
                if (theDate.day() === 6 || theDate.day() === 0) {
                    // add weekend to activeDates
                    this.activeDates.push(theDate.format("YYYY-MM-DD"));
                }
                theDate = theDate.add(1, "day");
            }
        },
        addWeekendCurrentYear() {
            this.removeWeekendCurrentYear();
            let theDate = dayjs(`${this.year}-01-01`);
            let isActiveDateUsingString =
                this.activeDates.length && typeof this.activeDates[0] === "string";
            while (theDate.diff(theDate.endOf("year"), "day") !== 0) {
                if (theDate.day() === 6 || theDate.day() === 0) {
                    // add weekend to activeDates
                    let oDate = isActiveDateUsingString ?
                        theDate.format("YYYY-MM-DD") :
                        { date: theDate.format("YYYY-MM-DD") };
                    this.activeDates.push(oDate);
                }
                theDate = theDate.add(1, "day");
            }
        },
        removeWeekendCurrentYear() {
            this.activeDates = this.activeDates.filter(oDate => {
                let date = typeof oDate === "string" ? oDate : oDate.date;
                let day = dayjs(date).day();
                let isCurrentYear = dayjs(date).year() === this.year;
                let isWeekend = [6, 0].includes(day);
                return !(isCurrentYear && isWeekend);
            });
        },
        getHolidays() {
            serviceHolidays.getHolidays().then(response => {
                if (response.data.status == true) {
                    for (let day in response.data.Dates) {
                        this.activeDates.push({
                            date:day,
                            className: "green"
                        });
                    }
                }
            })
            .catch(erro => {
                console.log(erro);
            });
        },
        getDatesDeliveryPoint() {
            let idSelectedProviderAppointment
            this.selected.forEach(id => {
                idSelectedProviderAppointment = id
            });
            if(idSelectedProviderAppointment == undefined)[
                idSelectedProviderAppointment = 0
            ]
            ServiceAppointment.getSetDates(idSelectedProviderAppointment)
                .then(response => {
                    if (response.data.status == true) {
                        for (let day in response.data.Dates) {
                            this.activeDates.push({
                                date: day,
                                className: "blue"
                            });
                        }
                    }
                })
                .catch(erro => {
                    console.log(erro);
                });
        },
        saveItemDate(item) {
            if (this.selected === null) {
                this.$notify({
                    group: "app",
                    type: "success",
                    text: "Escoger un prestador."
                });
                dateInfo.selected = false;
                dateInfo.className = "";
                return;
            }
            for (let i = 0; i < this.selected.length; i++) {
                this.idBranch = this.selected[i];
                console.log(this.idBranch);
            }

            this.loading = true;
            let festivos = this.activeDates.map(p => p.date);
            for (let i = 0; i < item.length; i++) {
                let aux = {};
                let theDate = dayjs(`${this.year}-01-01`);
                let endDate = dayjs(`${this.year}-12-31`);
                aux.idBranch = "";
                aux.idBranch = item[i];
                aux.idAppointment = [];
                while (endDate.diff(theDate, "day") !== 0) {
                    if (!festivos.includes(theDate.format("YYYY-MM-DD"))) {
                        switch (theDate.day()) {
                            case 0:
                                if (this.vue.domingo === true)
                                    aux.idAppointment.push({
                                        Date: theDate.format("YYYY-MM-DD"),
                                        idUser: StorageService.getUserData().id,
                                        startTime: this.time.domingo
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        endDate: this.timeFinish.domingo
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        rankOfTime: parseInt(this.range.domingo),
                                        capacity: parseInt(this.capacity.domingo),
                                        responseDay: parseInt(this.dayAnswer.domingo)
                                    });
                                break;
                            case 1:
                                if (this.vue.lunes === true)
                                    console.log(
                                        this.timeFinish.lunes
                                        .toISOString()
                                        .slice(11, 16)
                                        .replace("T", " ")
                                    );
                                aux.idAppointment.push({
                                    Date: theDate.format("YYYY-MM-DD"),
                                    idUser: StorageService.getUserData().id,
                                    startTime: this.time.lunes
                                        .toISOString()
                                        .slice(11, 16)
                                        .replace("T", " "),
                                    endDate: this.timeFinish.lunes
                                        .toISOString()
                                        .slice(11, 16)
                                        .replace("T", " "),
                                    rankOfTime: parseInt(this.range.lunes),
                                    capacity: parseInt(this.capacity.lunes),
                                    responseDay: parseInt(this.dayAnswer.lunes)
                                });
                                break;
                            case 2:
                                if (this.vue.martes === true)
                                    aux.idAppointment.push({
                                        Date: theDate.format("YYYY-MM-DD"),
                                        idUser: StorageService.getUserData().id,
                                        startTime: this.time.martes
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        endDate: this.timeFinish.martes
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        rankOfTime: parseInt(this.range.martes),
                                        capacity: parseInt(this.capacity.martes),
                                        responseDay: parseInt(this.dayAnswer.martes)
                                    });
                                break;
                            case 3:
                                if (this.vue.miercoles === true)
                                    aux.idAppointment.push({
                                        Date: theDate.format("YYYY-MM-DD"),
                                        idUser: StorageService.getUserData().id,
                                        startTime: this.time.miercoles
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        endDate: this.timeFinish.miercoles
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        rankOfTime: parseInt(this.range.miercoles),
                                        capacity: parseInt(this.capacity.miercoles),
                                        responseDay: parseInt(this.dayAnswer.miercoles)
                                    });
                                break;
                            case 4:
                                if (this.vue.jueves === true)
                                    aux.idAppointment.push({
                                        Date: theDate.format("YYYY-MM-DD"),
                                        idUser: StorageService.getUserData().id,
                                        startTime: this.time.jueves
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        endDate: this.timeFinish.jueves
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        rankOfTime: parseInt(this.range.jueves),
                                        capacity: parseInt(this.capacity.jueves),
                                        responseDay: parseInt(this.dayAnswer.jueves)
                                    });
                                break;
                            case 5:
                                if (this.vue.viernes === true)
                                    aux.idAppointment.push({
                                        Date: theDate.format("YYYY-MM-DD"),
                                        idUser: StorageService.getUserData().id,
                                        startTime: this.time.viernes
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        endDate: this.timeFinish.viernes
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        rankOfTime: parseInt(this.range.viernes),
                                        capacity: parseInt(this.capacity.viernes),
                                        responseDay: parseInt(this.dayAnswer.viernes)
                                    });
                                break;
                            case 6:
                                if (this.vue.sabado === true)
                                    aux.idAppointment.push({
                                        Date: theDate.format("YYYY-MM-DD"),
                                        idUser: StorageService.getUserData().id,
                                        startTime: this.time.sabado
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        endDate: this.timeFinish.sabado
                                            .toISOString()
                                            .slice(11, 16)
                                            .replace("T", " "),
                                        rankOfTime: parseInt(this.range.sabado),
                                        capacity: parseInt(this.capacity.sabado),
                                        responseDay: parseInt(this.dayAnswer.sabado)
                                    });
                                break;
                        }
                    }
                    theDate = theDate.add(1, "day");
                }
                aux.idBranch = this.idBranch;
                console.log(aux.idBranch);
                aux.active = 1;
                aux.lastCreated = new Date().toISOString().substr(0, 10);

                this.saveDayEnable.push(aux);
            }
            // let tableSave = JSON.stringify(this.saveDayEnable)
            console.log(this.saveDayEnable);
            ServiceAppointment.saveCalendarAppointment({
                    AppointmentDetails: this.saveDayEnable
                })
                .then(result => {
                    console.log(result);
                    console.log(result.data);
                    if (result.data.code === "Save successful") {
                        this.loading = false;
                        this.saveDayEnable = [];
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: "Calendario configurado éxito."
                        });
                        this.selected = "";
                    }
                })
                .catch(erro => {
                    this.loading = false;
                    console.log(erro);
                    this.saveDayEnable = [];
                    if (result.data.message === "Request failed with status code 500") {
                        this.loading = false;
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "Error Almacenado."
                        });
                    }
                });
        },
        init() {
            this.getHolidays();
        },

        getCities() {
            locationService.getCitiesByState(this.location.state).then(response => {
                this.cities = response.data;
            });
        }
    }
};